import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import * as moment from "moment";
import {Geolocation} from "@capacitor/geolocation";


const CACHE_FOLDER = 'CACHED-IMG';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {

  public static localhost = 'localhost';

  constructor(
  ) {
  }

  public contiene(cadena: any, subcadena: any): boolean {
    let contiene = false;
    if (cadena.toLowerCase().indexOf(subcadena.toLowerCase()) !== -1) {
      contiene = true;
    }
    return contiene;
  }

  public static contiene(cadena: any, subcadena: any): boolean {
    let contiene = false;
    if (cadena.toLowerCase().indexOf(subcadena.toLowerCase()) !== -1) {
      contiene = true;
    }
    return contiene;
  }

  public formatearFecha(fecha : any , formato? : any): any {
    const fechaSeteada = '';
    if (fecha && fecha !== '-') {
      return moment(fecha).format(formato ? formato : 'YYYY-MM-DD HH:mm:ss');
    }
    return fechaSeteada;
  }


  public sumarDias(fecha : Date, dias : number) : Date{
    fecha.setDate(fecha.getDate() + dias);
    return fecha;
  }

  public restarDias(fecha : Date, dias : number) : Date{
    fecha.setDate(fecha.getDate() - dias);
    return fecha;
  }

  getInicioMesActual(date: Date = new Date()) {
    return new Date(date.getFullYear(), date.getMonth(), 1);
  }

  public static getDominio(): string {
    const hostName = window.location.hostname;
    let urlParts = hostName.split('.');
    if (hostName == this.localhost) {
      return hostName;
    } else if (Array.isArray(urlParts) && urlParts.length > 0) {
      urlParts.splice(0, 1);
      return urlParts.join('.');
    }
  }

  public static getSubdomain(): string {
    let hostname = window.location.hostname;
    let urlParts = hostname.split('.');

    if (hostname == this.localhost) {
      return hostname;
    } else if (Array.isArray(urlParts) && urlParts.length > 0) {
      return urlParts[0];
    }
  }

  public static getUrlService() {
    let subdominioFront = this.getSubdomain();
    let dominio = this.getDominio();
    let subdominioBack = '';

    subdominioBack = 'services';
    if (this.contiene(subdominioFront, "qas")) {
      subdominioBack = 'services-qas';
    } else if (subdominioFront == 'localhost') {
      subdominioBack = 'localhost';
    }

    let url = 'http://localhost/misteryfoodapi';
    if (subdominioBack != 'localhost') {
      url = 'https://' + subdominioBack + '.' + dominio;
    }

    return url;
  }

  public numeroDeSemana(fecha = new Date()) {
    const DIA_EN_MILISEGUNDOS = 1000 * 60 * 60 * 24,
      DIAS_QUE_TIENE_UNA_SEMANA = 7,
      JUEVES = 4;
    fecha = new Date(Date.UTC(fecha.getFullYear(), fecha.getMonth(), fecha.getDate()));
    let diaDeLaSemana = fecha.getUTCDay(); // Domingo es 0, sábado es 6
    if (diaDeLaSemana === 0) {
      diaDeLaSemana = 7;
    }
    fecha.setUTCDate(fecha.getUTCDate() - diaDeLaSemana + JUEVES);
    const inicioDelAnio = new Date(Date.UTC(fecha.getUTCFullYear(), 0, 1));
    const diferenciaDeFechasEnMilisegundos = fecha.getTime() - inicioDelAnio.getTime();
    return Math.ceil(((diferenciaDeFechasEnMilisegundos / DIA_EN_MILISEGUNDOS) + 1) / DIAS_QUE_TIENE_UNA_SEMANA);
  };

  public getWeekList(){
    let weekList : any[] = [];
    for (let i=1; i <= 52; i++){
      weekList.push({"week_id" : i, "week_name": i});
    }
    return weekList;
  }

  checkPermissionUser(permiso_codigo) : boolean{
    let tienePermiso = false;
    if(permiso_codigo != null && permiso_codigo != ""){
      let permisoString = localStorage.getItem('permisos') ?? '';
      if (permisoString != null && permisoString != ""){
        let permisoList = permisoString.toString().split(',');
        if(permisoList?.length > 0){
          permisoList.forEach( permiso =>{
            if(permiso == permiso_codigo){
              tienePermiso = true;
            }
          })
        }
      }
    }
    return tienePermiso;
  }

  static checkPermissionUser(permiso_codigo) : boolean{
    let tienePermiso = false;
    if(permiso_codigo != null && permiso_codigo != ""){
      let permisoString = localStorage.getItem('permisos') ?? '';
      if (permisoString != null && permisoString != ""){
        let permisoList = permisoString.toString().split(',');
        if(permisoList?.length > 0){
          permisoList.forEach( permiso =>{
            if(permiso == permiso_codigo){
              tienePermiso = true;
            }
          })
        }
      }
    }
    return tienePermiso;
  }

  public checkHttp(url): boolean {
    return this.contiene(url, 'http');
  }

  public static getEndpoints(){
    return {
      auth: {
        login: 'usuario/iniciaSesion',
        loginGoogle: 'usuario/iniciaSesionG',
        loginInfoGoogle: 'usuario/iniciaSesionInfoGoogle',
        createAccount: 'usuario/createAccount',
      },
      products: {
        listarPorPaginacion : 'producto/listarPorPaginacion',
        getProductosPaginados : 'producto/getProductosPaginados',
        getAllActivos : 'producto/getAllActivos',
        getByID : 'producto/getByID',
        add : 'producto/add',
        update : 'producto/update',
        save : 'producto/saveProducto',
      }
    }
  }

  public static existeToken(){
    return localStorage.getItem('accessToken') && localStorage.getItem('refreshToken') != "";
  }

  public async getCurrentPosition(): Promise<{ latitude: any, longitude: any }> {
    try {
      const position = await Geolocation.getCurrentPosition();
      return { latitude: position?.coords?.latitude, longitude: position?.coords?.longitude };
    } catch (error) {
      return { latitude: null, longitude: null };
    }
  }

  public static getTotalItemsCarrito() : number{
    let totalItems : any = localStorage.getItem('totalItemsCarrito') ?? 0;

    if(totalItems > 0) return Number(totalItems);
    return 0;
  }

  public static parseFloatDecimales(numero : number, decimales : number){
    return parseFloat(numero.toFixed(decimales));
  }

}



